<div
  class="fx-row fx-wrap swiper fx-row-h-center"
  [class.product-and-swiper]="productImages?.length > 1 && !isSolution"
  >
  @if (swiperTitle != '') {
    <h3 class="swiper-container-title mb-3">{{ swiperTitle }}</h3>
  }
  <div class="w-100 swiper-container-wrapper">
    <div class="swiper-container" [ngClass]="containerClass">
      <div class="swiper-wrapper">
        <ng-content></ng-content>
      </div>
      @if (navType == 'innerBottom') {
        <div
          class="swiper-inner-bottom-navigation fx-row fx-row-h-center fx-row-v-center"
          >
          <mat-icon
            class="swiper-button-prev-inner-bottom"
            (click)="prevSlide()"
            [attr.role]="'button'"
            [attr.aria-hidden]="false"
            tabindex="0"
            aria-label="Previous slide"
            (keydown.enter)="prevSlide()"
            (keydown.space)="prevSlide(); $event.preventDefault()"
            >chevron_left</mat-icon>
          @if (productImages?.length > 1) {
            <div style="width: 100%; height: 50px">
              @for (image of productImages; track image) {
                <img [src]="image" class="product-swiper-image" />
              }
            </div>
          }
          @if (environment.siteAbbr === 'spc') {
            <span class="slide-counter ml-2 mr-2"
              >{{ slideCounter }} of {{ swiper?.slides?.length }}</span
              >
            }
            <mat-icon
            class="swiper-button-next-inner-bottom"
            (click)="nextSlide()"
            [attr.role]="'button'"
            [attr.aria-hidden]="false"
            tabindex="0"
            aria-label="Next slide"
            (keydown.enter)="nextSlide()"
            (keydown.space)="nextSlide(); $event.preventDefault()"
            >chevron_right</mat-icon>
          </div>
        }
      </div>
    </div>
    @if (showPrevArrow && navType == 'normal') {
      <div
        class="swiper-button-prev-normal fx-row fx-row-v-center fx-row-h-center"
        role="button"
        tabindex="0"
        aria-label="Previous slide"
        (click)="prevSlide()"
        (keydown.enter)="prevSlide()"
        (keydown.space)="prevSlide(); $event.preventDefault()"
        >
        <mat-icon>chevron_left</mat-icon>
      </div>
    }
    @if (showNextArrow && navType == 'normal') {
      <div
        class="swiper-button-next-normal fx-row fx-row-v-center fx-row-h-center"
        role="button"
        tabindex="0"
        aria-label="Next slide"
        (click)="nextSlide()"
        (keydown.enter)="nextSlide()"
        (keydown.space)="nextSlide(); $event.preventDefault()"
        >
        <mat-icon>chevron_right</mat-icon>
      </div>
    }
    @if (navType == 'bottom' && swiper?.slides?.length > 1) {
      <div
        class="swiper-bottom-navigation fx-row fx-row-v-center fx-row-h-center mt-2"
        >
        <mat-icon
            class="swiper-button-prev-unique no-border"
            (click)="prevSlideSPC()"
            [attr.role]="'button'"
            [attr.aria-hidden]="false"
            tabindex="0"
            aria-label="Previous slide"
            (keydown.enter)="prevSlideSPC()"
            (keydown.space)="prevSlideSPC(); $event.preventDefault()"
            >chevron_left</mat-icon>
        <span class="slide-counter ml-2 mr-2">{{ slideCounter }} of {{ swiper?.slides?.length }}</span>
        <mat-icon
            class="swiper-button-next-unique no-border"
            (click)="nextSlideSPC()"
            [attr.role]="'button'"
            [attr.aria-hidden]="false"
            tabindex="0"
            aria-label="Next slide"
            (keydown.enter)="nextSlideSPC()"
            (keydown.space)="nextSlideSPC(); $event.preventDefault()"
            >chevron_right</mat-icon>
      </div>
    }
  </div>
